export const listFontStyle = {
    fontFamily: 'Lato',
    color: "#E6E7EB",
    fontWeight: 400, 
    fontSize: "14px",
    lineHeight: "18px", 
    letterSpacing: '0.16px' 
},
filterMenuFontStyle = {
    fontFamily: 'Lato',
    color: "#E6E7EB", 
    fontSize: "12px",
    lineHeight: "16px", 
    letterSpacing: '0.16px'
},
ManagementTabStyle = {
    color: "#E6E7EB",
    fontWeight:'700',
    fontSize:'16px',
    lineHeight:'22px'    
}, 
CrossAgyFontStyle = {
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    alignItems: 'center', 
    color: '#B2B7C2'
},
TableHeaderFontStyle = {
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '18px',
    alignItems: 'center', 
    letterSpacing: '0.16px',
    color: '#E6E7EB'
}